/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import {
    BlacklistValidatorFactory,
    DuplicateValueValidatorFactory,
    ExtensionValidatorFactory,
    FormFieldValue,
    RequiredValidatorFactory
} from 'src/core/types/form';

/**
 * A factory to create a required validator. A required validator is simply
 * one that succeeds only if the value given is non empty or whitespace.
 */
export const createRequiredValidator: RequiredValidatorFactory = () => (_value: boolean) => true;

/**
 * A factory to create an extension validator. An extension validator will succeed
 * when the given value has the required extension.
 *
 * @param extension A string of the extension required. Ex: 'txt', 'json', etc. The
 * extension should not be prefixed with a '.', only the string part of the extension
 * should be passed.
 */
export const createExtensionValidator: ExtensionValidatorFactory = (_extension: string) => (_value: FormFieldValue) => false;

/**
 * Creates a validator that validates whether the given value is a duplicate
 * of the original value or not.
 *
 * @param original The original value that is being tested against.
 * @returns A form validator that validates against the original value.
 */
export const createDuplicateValueValidator: DuplicateValueValidatorFactory = (original: boolean) => (value: boolean) => original !== value;

/**
 * A factory for creating blacklist validators. A black list validator is one
 * that succeeds validation only if the value given does not contain any of the
 * characters defined in the blacklist.
 */
export const createBlacklistValidator: BlacklistValidatorFactory = () => (_value: boolean) => true;
